import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import deleteIcon from 'core/assets/svg/delete-icon.svg';

import { ActionButton } from 'core/components/action-button';
import useSession from 'core/hooks/use-session';

import useStyles from './properties-form.styles';

const Property = ({ index, item, onRemove, propertyType }) => {
  const classes = useStyles();
  const { viewOnly } = useSession();

  const isRental = propertyType === 'rental';
  const titleText = isRental ? `Rental property ${index + 1}` : `Additional residence ${index + 1}`;

  // Constructing address display
  const addressText = item.address
    ? `${item.address}${item.address2 ? `, ${item.address2}` : ''}, ${item.city}, ${item.state} ${item.zip}`
    : '';

  const handleDelete = () => {
    if (onRemove) {
      onRemove(index);
    }
  };

  return (
    <div className={classes.propertyItem}>
      <div className={classes.propertyContent}>
        <div className={classes.propertyInfo}>
          <h3 className={classes.propertyTitle}>{titleText}</h3>
          <p className={classes.propertyAddress}>{addressText}</p>
        </div>

        {!viewOnly && (
          <ActionButton onClick={handleDelete} className={classes.deleteButton} icon={deleteIcon} size="small" />
        )}
      </div>
    </div>
  );
};

Property.propTypes = {
  index: PropTypes.number.isRequired,
  item: PropTypes.shape({
    address: PropTypes.string,
    address2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string
  }).isRequired,
  onRemove: PropTypes.func,
  propertyType: PropTypes.string.isRequired
};

export default observer(Property);
